import http from "./httpService";

export function createpost(postbody) {
  return http.post(`${process.env.REACT_APP_API}/posts/create`, {
    title: postbody.title,
    description: postbody.description,
    tags: postbody.tags
  });
}